import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import blogData from './blogData';
import './BlogPostMobile.css';

const BlogPostMobile = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const blog = blogData[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!blog) {
    return (
      <>
        <section className="main-hero demo-hero bpm-hero">
          <div className="hero-gif-fade-left"></div>
          <div className="hero-gif-fade-right"></div>
          <h1 className="hero-page-title">Not Found</h1>
        </section>
        <section className="bpm-content">
          <div className="bpm-layout">
            <p className="bpm-not-found">This article could not be found.</p>
            <span className="bpm-back-link" onClick={() => { navigate('/resources'); window.scrollTo(0, 0); }}>
              ← Back to Resources
            </span>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <section className="main-hero demo-hero bpm-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">{blog.category}</h1>
      </section>

      <section className="bpm-content">
        <div className="bpm-layout">
          <div className="bpm-meta-row">
            <span className="bpm-tag">{blog.tag}</span>
            <span className="bpm-date">{blog.date}</span>
          </div>

          <h1 className="bpm-title">{blog.title}</h1>

          <div className="bpm-author-row">
            <img src={blog.img} alt="" className="bpm-author-img" />
            <div className="bpm-author-info">
              <span className="bpm-author-name">{blog.author}</span>
              <span className="bpm-read-time">{blog.readTime}</span>
            </div>
          </div>

          <div className="bpm-divider"></div>

          <article className="bpm-article">
            {blog.sections.map((section, i) => (
              <div key={i} className="bpm-section">
                <h2 className="bpm-section-heading">{section.heading}</h2>
                {section.paragraphs.map((p, j) => (
                  <p key={j} className="bpm-paragraph">{p}</p>
                ))}
              </div>
            ))}
          </article>

          <div className="bpm-divider"></div>

          <div className="bpm-cta">
            <p className="bpm-cta-text">Ready to secure your AI systems?</p>
            <button className="bpm-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
          </div>

          <span className="bpm-back-link" onClick={() => { navigate('/resources'); window.scrollTo(0, 0); }}>
            ← Back to Resources
          </span>
        </div>
      </section>
    </>
  );
};

export default BlogPostMobile;
